import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { postData, putData } from "../../Services/apiService";
import { useAlert } from "../../Provider/Alert/AlertContext";

export function useContractForm({
    idClient,
    contract = null,
    onClose = () => {},
}) {
    const { t } = useTranslation(); // Translation hook
    const { addAlert } = useAlert(); // Alert hook
    const [formContract, setFormContract] = useState({
        description: "",
        is_active: true,
    }); // Form contract hook
    const [btnDisable, setBtnDisable] = useState(false); // Disable button hook
    const [isEditing, setIsEditing] = useState(false); // Is editing hook

    // Effect to set form data when editing
    useEffect(() => {
        // Only treat as editing when contract contains meaningful data
        // (incoming empty objects like {} should be treated as 'create')
        if (contract && contract.id) {
            setFormContract({
                description: contract.description || "",
                is_active:
                    contract.is_active !== undefined
                        ? contract.is_active
                        : true,
            });
            setIsEditing(true);
        } else {
            // Reset to defaults when there's no contract to edit
            setFormContract({
                description: "",
                is_active: true,
            });
            setIsEditing(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contract]);

    // Handle form submission
    const handleFormSubmit = async () => {
        setBtnDisable(true);

        console.log("Submitting form:", formContract);

        try {
            let save = null;

            if (isEditing) {
                save = await putData(
                    `/client/${idClient}/contract`,
                    contract.id,
                    formContract
                );
            } else {
                save = await postData(
                    `/client/${idClient}/contract`,
                    formContract
                );
            }

            console.log("Response from server:", save);

            if (save.status === 200 || save.status === 201) {
                addAlert(
                    "success",
                    t("contract.form.alert.success.title"),
                    t("contract.form.alert.success.message")
                );
                onClose();
                setFormContract({
                    description: "",
                    is_active: true,
                });
                return;
            }

            console.error("Unexpected response:", save);
            addAlert(
                "danger",
                t("contract.form.alert.error.title"),
                t("contract.form.alert.error.message")
            );
        } catch (error) {
            console.error("Error submitting form:", error);
            addAlert(
                "danger",
                t("contract.form.alert.error.title"),
                t("contract.form.alert.error.message")
            );
        }
    };

    const handleFormCancel = () => {
        setFormContract({
            description: "",
            is_active: true,
        });
        setBtnDisable(false);
        onClose();
    };

    return {
        isEditing,
        formContract,
        setFormContract,
        btnDisable,
        handleFormSubmit,
        handleFormCancel,
    };
}
